// Shared mapping from league season history to trophy-cabinet items, used
// by both the league palmarés and the career timeline.

import type { LeagueHistoryEntry } from '@/config/leagueConfig'
import { DIVISIONS } from '@/config/leagueConfig'
import type { TrophyCabinetItem } from '../components/broadcast'

export function seasonsToTrophyItems(
  history: LeagueHistoryEntry[],
  opts: { idPrefix?: string; clubName?: string } = {},
): TrophyCabinetItem[] {
  const { idPrefix = 'season', clubName } = opts
  return [...history].reverse().map(h => {
    const champion = h.position === 1
    const promoted = !champion && h.position <= 2 && h.division > 1
    const note = champion ? ' · Campeones' : promoted ? ' · Ascenso' : ''
    return {
      id: `${idPrefix}-${h.season}-${h.division}`,
      label: `${DIVISIONS[h.division].name} — ${h.position}º`,
      sublabel: `${clubName ? clubName + ' · ' : ''}Temporada ${h.season}${note}`,
      tier: champion ? 'gold' : promoted ? 'silver' : 'bronze',
      highlight: champion,
    }
  })
}
